import { message } from 'antd';

export const LCMessage = message;
